import { FileIcon, FileQuestionIcon, FileSpreadsheetIcon, FileTextIcon, PresentationIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { isNamedSourceType, type KnowledgeSourceType, type NamedSourceType } from '@/entities/knowledgeSources';
import { DOWNLOAD_FORMAT_BADGE_CLASS } from '@/shared/lib';

type FileTypeConfig = {
  icon: ReactNode;
  /** Оформление лейбла формата; у типа без своего формата скачивания лейбл нейтральный */
  badgeClass?: string;
};

// Иконка нейтрального цвета, цвет лейбла различает тип файла.
// Цвет берётся из общего оформления форматов {@link DOWNLOAD_FORMAT_BADGE_CLASS}: тип источника
// помечается так же, как формат при скачивании. Для типа вне этого перечня лейбл нейтральный
const fileTypeConfig: Record<NamedSourceType, FileTypeConfig> = {
  pdf: {
    icon: <FileTextIcon className="size-4 shrink-0 text-muted-foreground" />,
    badgeClass: DOWNLOAD_FORMAT_BADGE_CLASS.pdf,
  },
  word: {
    icon: <FileIcon className="size-4 shrink-0 text-muted-foreground" />,
    badgeClass: DOWNLOAD_FORMAT_BADGE_CLASS.docx,
  },
  excel: {
    icon: <FileSpreadsheetIcon className="size-4 shrink-0 text-muted-foreground" />,
    badgeClass: DOWNLOAD_FORMAT_BADGE_CLASS.xlsx,
  },
  powerpoint: {
    icon: <PresentationIcon className="size-4 shrink-0 text-muted-foreground" />,
  },
};

// Нейтральный запасной маркер для типов, подписанных «Другим»
const fallbackFileTypeConfig: FileTypeConfig = {
  icon: <FileQuestionIcon className="size-4 shrink-0 text-muted-foreground" />,
};

/** Оформление типа источника; нераспознанный тип получает нейтральный запасной маркер вместо сбоя */
export const getFileTypeConfig = (sourceType: KnowledgeSourceType): FileTypeConfig =>
  isNamedSourceType(sourceType) ? fileTypeConfig[sourceType] : fallbackFileTypeConfig;
